export default "__VITE_ASSET__7b42d6c8__"